import React from 'react';
import { ReferenceChip } from '@/components/ReferenceChip';

/**
 * InlineReference — the house format for showing an order's running
 * (reference / page) number next to its Order No.
 *
 * Renders `(Page: 1001)` where the label word ("Page", "Reference",
 * "Order", … from the company's Reference config) stays neutral grey and
 * ONLY the numeric value is painted in the app's signature issued-blue
 * (`--req-issued` / #1D4ED8). The whole chip stays clickable (opens the
 * Order Forms page filtered to this reference in a new tab) via
 * {@link ReferenceChip}.
 *
 * Reused across the Dashboard + Goldsmith Detail so every order shows its
 * reference identically. Renders nothing when the company does not use
 * reference numbers or the order has none.
 */
export function InlineReference({
  referenceNo,
  labelShort = 'Page',
  testId,
  valueSize = 'text-[11px]',
  className = '',
}) {
  if (referenceNo == null || referenceNo === '') return null;
  return (
    <ReferenceChip
      referenceNo={referenceNo}
      testId={testId}
      title={`${labelShort} ${referenceNo} — open in Order Forms (new tab)`}
      className={`inline text-slate-500 hover:text-slate-700 ${valueSize} ${className}`}
    >
      ({labelShort}:{' '}
      <span className="font-mono font-semibold text-[var(--req-issued)]">{referenceNo}</span>
      )
    </ReferenceChip>
  );
}

export default InlineReference;
